import {
  Recommendation,
  RecommendationStatus,
  RecommendationType,
} from "@/services/recommendations/recommendations";
import { DeepReadonly } from "vue";
export function recommendationHasStatus(
  r: DeepReadonly<Recommendation>,
): RecommendationStatus | undefined {
  if (r.todoCount > 0 || r.inProgressCount > 0) {
    return RecommendationStatus.OPEN;
  }
  if (r.todoCount === 0 && r.inProgressCount === 0 && r.doneCount > 0) {
    return RecommendationStatus.DONE;
  }
  if (r.taskCount > 0 && r.dismissedCount === r.taskCount) {
    return RecommendationStatus.DISMISSED;
  }
}

// The tasks of the section the recommendation is listed in. `taskCount` mixes
// every status but VERIFIED, so it would count a recommendation's dismissed
// tasks on its open and done cards too.
//
// `section` is the active status filter. ASSIGNED cannot be derived from the
// recommendation's own counts — it is a slice of the open ones belonging to
// this user — so a card there counted every open task in the organization.
export function recommendationSummaryCount(
  r: DeepReadonly<Recommendation>,
  section?: RecommendationStatus,
): number {
  if (section === RecommendationStatus.ASSIGNED) {
    return r.assignedToMeCount;
  }
  switch (recommendationHasStatus(r)) {
    case RecommendationStatus.OPEN:
      return r.todoCount + r.inProgressCount;
    case RecommendationStatus.DONE:
      return r.doneCount;
    case RecommendationStatus.DISMISSED:
      return r.dismissedCount;
    default:
      return r.taskCount;
  }
}

export function toURLParam(recommendationType: RecommendationType): string {
  return recommendationType.replace(/_/g, "-").toLowerCase();
}
